import React from "react";

export default function Textarea({
  id,
  name,
  required = true,
  placeholder,
  label,
  value,
  onChange,
  md,
  disabled = false,
}) {
  return (
    <div className={`w-full p-2 ${md == 6 ? "md:w-1/2" : ""}`}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-900">
        {label || (name ? name.charAt(0).toUpperCase() + name.slice(1) : "")}
      </label>

      <div className="relative mt-2">
        <textarea
          id={id}
          name={name}
          required={required}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 
            outline outline-2 h-24 outline-slate-200 placeholder-gray-400
            focus:outline-2 focus:outline-indigo-600 sm:text-sm resize-none"
        />
      </div>
    </div>
  );
}
